import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.ChangeDueDateSelection,
  { key: LocationVarKey.ChangeDueDate1, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "custom") },
  { key: LocationVarKey.ChangeDueDate2, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "custom") },
  { key: LocationVarKey.ChangeDueDate3, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "1st") },
  { key: LocationVarKey.ChangeDueDate4, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "1st") },
  { key: LocationVarKey.ChangeDueDate5, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "15th") },
  { key: LocationVarKey.ChangeDueDate6, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "15th") },
  { key: LocationVarKey.ChangeDueDate7, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "anniversary") },
  { key: LocationVarKey.ChangeDueDate8, hideIf: IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "anniversary") },
  LocationVarKey.HasChangeDueDate
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Due Date
      </PageHeader>

      <DropdownRow
        {...page}
        marginTop
        label=" Due on"
        keyName={LocationVarKey.ChangeDueDateSelection}
        options={[
          {
            label: "Custom",
            value: "custom"
          },
          {
            label: "1st of the Month",
            value: "1st"
          },
          {
            label: "15th of the Month",
            value: "15th"
          },
          {
            label: "Anniversary Date",
            value: "anniversary"
          }
        ]}
      />

      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "custom")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ChangeDueDate1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "custom")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.ChangeDueDate2}
        enableSwitchVar={LocationVarKey.ChangeDueDate2Enabled}
      />

      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "1st")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ChangeDueDate3}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "1st")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.ChangeDueDate4}
        enableSwitchVar={LocationVarKey.ChangeDueDate4Enabled}
      />

      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "15th")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ChangeDueDate5}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "15th")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.ChangeDueDate6}
        enableSwitchVar={LocationVarKey.ChangeDueDate6Enabled}
      />

      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "anniversary")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.ChangeDueDate7}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.ChangeDueDateSelection, "anniversary")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.ChangeDueDate8}
        enableSwitchVar={LocationVarKey.ChangeDueDate8Enabled}
      />

      <SwitchRow {...page} keyName={LocationVarKey.HasChangeDueDate} label="Customers can change due date" />
    </>
  );
}
